module.exports = __webpack_public_path__ + "static/media/google.f6c73458.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/google.svg
// module id = 604
// module chunks = 0